import React from 'react';
import { useTranslation } from 'react-i18next';
import * as S from './PendingInvoiceLink.styled';
import { SmallChevronIcon } from '@/components/UI/Icons/Icons';
import { ROUTES } from '@/constants/routes';

type PendingInvoiceLinkProps = {
  isPendingInvoice?: boolean | null;
  className?: string;
};

export function PendingInvoiceLink({
  isPendingInvoice,
  className,
}: PendingInvoiceLinkProps) {
  const { t } = useTranslation();

  if (!isPendingInvoice) return null;

  return (
    <S.Link
      className={className}
      href={`${ROUTES.businessInvoices}?status=UNPAID`}
    >
      <S.BellImage src="/images/bell.png" width={16} height={16} alt="" />
      <S.Text>{t('pages.cabinet.invoice_is_waiting_payment')}</S.Text>
      <SmallChevronIcon width={7} height={12} />
    </S.Link>
  );
}
